<template>
    <Dialog v-model:visible="internalValue" modal :closable="true" class="new-certificate-dialog"
            :header="$t('message.horseEdit.covering.dialogCertificateHeader') + ' ' + horseName"
            :style="{ width: '70vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <TabView>
            <TabPanel header="Covering certificate">
                <NewCertificateDialogAgrementTab v-model="internalValue" :horseName="horseName" @search="emitSearch" @refreshHorse="$emit('refreshHorse')" />
            </TabPanel>
            <TabPanel header="External Stallion">
                <NewCertificateDialogExternalStallionTab v-model="internalValue" @search="emitSearch" @refreshHorse="$emit('refreshHorse')" />
            </TabPanel>
        </TabView>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import CustomCalendar from '@/components/form/CustomCalendar.vue';
import CustomInputNumber from '@/components/form/CustomInputNumber.vue';
import CustomInputText from '@/components/form/CustomInputText.vue';
import CustomSelectOne from '@/components/form/inner/CustomSelectOne.vue';
import CustomButton from '@/components/form/CustomButton.vue';
import CustomSelectOneCoveringType from '@/components/form/CustomSelectOneCoveringType.vue';
import CustomInputTextArea from '@/components/form/CustomInputTextArea.vue';
import CustomSelectOneSemenType from "@/components/form/CustomSelectOneSemenType.vue";
import CustomSelectOneSemenOrigin from "@/components/form/CustomSelectOneSemenOrigin.vue";
import { Form as VeeForm } from 'vee-validate';
import CustomSelectOneAgreementType from "@/components/form/CustomSelectOneAgreementType.vue";
import CustomSelectOneSeason from "@/components/form/CustomSelectOneSeason.vue";
import CustomSelectOneCity from "@/components/form/CustomSelectOneCity.vue";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import NewCertificateDialogAgrementTab
    from "@/views/horse/horseEdit/dialogs/NewCertificateDialogAgrementTab.vue";
import NewCertificateDialogExternalStallionTab
    from "@/views/horse/horseEdit/dialogs/NewCertificateDialogExternalStallionTab.vue";


export default {
    name: "NewCertificateDialog",

    components: {
        NewCertificateDialogExternalStallionTab,
        NewCertificateDialogAgrementTab,
        CustomSelectOneSeason,
        CustomSelectOneAgreementType,
        CustomSelectOne,
        CustomInputText,
        CustomInputNumber,
        Dialog,
        CustomButton,
        CustomSelectOneCoveringType,
        CustomSelectOneSemenType,
        CustomSelectOneSemenOrigin,
        CustomInputTextArea,
        CustomCalendar,
        VeeForm,
        CustomSelectOneCity,
        TabView,
        TabPanel
    },

    props: {
        modelValue: null,
        horseName: {
            type: String,
            default: "",
        },
    },

    emits: ["search", "update:modelValue", "refreshHorse"],

    data() {
        return {
        };
    },

    methods: {
        emitSearch() {
            this.$emit("search");
        }
    },

    computed: {
        internalValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
};
</script>

<style lang="scss">
    .new-certificate-dialog {
        .custom-input-text, .custom-input-number, .custom-select-one, .custom-calendar, .custom-input-textarea {
            padding-left: 170px;
            .custom-label {
                z-index: 999;
                position: absolute;
                transform: translateX(-100%);
                left: 160px;
                text-align: right;
            }
        }
        &.p-dialog {
            .p-dialog-header {
                justify-content: space-between;
                .p-dialog-title {
                    color: var(--accent-color);
                    font-family: var(--decor-font-family);
                    font-weight: 500;
                    font-size: 25px;
                }
            }
            .p-dialog-content {
                padding: 1.5rem;
            }
        }
        .certificate-box {
            .custom-input-text:nth-of-type(1) {
                padding-left: 100px;
                right: -70px;
                .custom-label {
                    left: 90px;
                }
            }
            .custom-input-text:nth-of-type(2) {
                padding-left: 100px;
            }
        }
    }
</style>
